const apiBaseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:8080').replace(/\/$/, '');

export const communityIconUrl = community => {
  if (!community?.iconUrl) return null;
  const path = community.iconUrl.startsWith('http')
    ? community.iconUrl
    : `${apiBaseUrl}${community.iconUrl}`;
  const version = community.updatedAt ? `v=${encodeURIComponent(community.updatedAt)}` : '';
  if (!version) return path;
  return `${path}${path.includes('?') ? '&' : '?'}${version}`;
};

export const communityDisplayName = community =>
  community?.displayName ||
  [community?.name, community?.area, community?.city]
    .filter(value => value && String(value).trim())
    .join(', ') ||
  'Community';

export const communityLocation = community =>
  [community?.area, community?.city, community?.state]
    .filter(value => value && String(value).trim())
    .join(', ');
